// extracted by mini-css-extract-plugin
export default {"tableEmptyMessageContainer":"TableEmptyMessage_tableEmptyMessageContainer__PmIsr","actionButton":"TableEmptyMessage_actionButton__WD+AA"};